import React, { useEffect, useRef } from 'react';
import { isClient } from '../../../../../helpers';

export default function StickyNavUpdater({ stickyNavState, setStickyNavState }) {
    const updateNavigationHighlight = useRef(() => {});

    const getDistanceTop = (target, windowScrollTop, innerHeight) => {
        return target ? Math.round(target.offsetTop - windowScrollTop - innerHeight) : 0;
    };

    const getDistanceBottom = (target, windowScrollTop, innerHeight) => {
        return target ? Math.round(target.offsetTop + target.offsetHeight - windowScrollTop - innerHeight) : 0;
    };

    useEffect(() => {
        updateNavigationHighlight.current = () => {
            const thisStickyNav = document.getElementById(stickyNavState.logicalName);
            const thisStickyInner = thisStickyNav ? thisStickyNav.getElementsByClassName('sticky-nav-inner')[0] : null;

            if (thisStickyNav && thisStickyInner) {
                const navData = [...stickyNavState.navigation];

                navData &&
                    navData.forEach((currentNavItem, navItemNum) => {
                        const target = document.getElementById(currentNavItem?.link);

                        if (target) {
                            const windowScrollTop =
                                typeof window.pageYOffset !== 'undefined'
                                    ? window.pageYOffset
                                    : (document.documentElement || document.body.parentNode || document.body).scrollTop;

                            const innerHeight = thisStickyInner.getBoundingClientRect().height;

                            const distanceTop = getDistanceTop(target, windowScrollTop, innerHeight);
                            const distanceBottom = getDistanceBottom(target, windowScrollTop, innerHeight);

                            if (distanceTop < 50 && distanceBottom > 50) {
                                navData[navItemNum].active = true;
                            } else {
                                navData[navItemNum].active = false;
                            }
                        }
                    });

                setStickyNavState(prevState => ({
                    ...prevState,
                    navigation: navData,
                }));
            }
        };

        const handleScroll = () => {
            updateNavigationHighlight.current();
        };

        if (isClient()) {
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (isClient()) {
                window.removeEventListener('scroll', handleScroll);
            }
        };
    }, [stickyNavState.navigation]);

    return null;
}
